var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c('el-pagination',{attrs:{"current-page":_vm.Data,"page-size":_vm.config.PageSize,"layout":"total, prev, pager, next","total":_vm.config.MaxSize,"background":""},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }